import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthToken } from "@/providers/context";
import { useUser } from "@/providers/context";

interface ProtectedRouteProps {
  children?: ReactNode | ReactNode[];
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { token } = useAuthToken();
  const { exp } = useUser();
  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }
  if (exp) {
    const now = Math.floor(Date.now() / 1000);
    if (now > exp) {
      console.debug("Expired token in ProtectedRoute");
      return null; // Token is expired, AuthProvider should refresh it
    }
  }

  return <>{children}</>;
};
